// EntityDashboard_With_Availability.js
// نسخة محدثة من EntityDashboard تتضمن إدارة أوقات العمل والاستثناءات

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import AvailabilitySchedule from '../components/AvailabilitySchedule';
import AvailabilityExceptions from '../components/AvailabilityExceptions';
import EntityBlockSlot from '../components/EntityBlockSlot'; 
const EntityDashboard = () => {
  const navigate = useNavigate();
  const [entity, setEntity] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [stats, setStats] = useState({
    totalAppointments: 0,
    todayAppointments: 0,
    pendingAppointments: 0,
    totalRevenue: 0
  });
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('dashboard');
  
  // حالات المودالات
  const [showBlockSlot, setShowBlockSlot] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);
  const [showExceptions, setShowExceptions] = useState(false);
  
  // حالة لتصفية الحجوزات
  const [filterDate, setFilterDate] = useState('');
  const [filterPart, setFilterPart] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  
    // لإزالة الوقت من التاريخ
  const formatDate = (dateString) => {
    return dateString.split("T")[0];
  };

  // لإظهار الساعة والدقائق فقط
  const formatTime = (timeString) => {
    if (!timeString) return "";
    return timeString.slice(0, 5); // يأخذ hh:mm فقط
  };

  // لو لديك مدة مثل "18:00:00 - 01:00:00"
  const formatTimeRange = (range) => {
    if (!range) return "";
    const [from, to] = range.split(" - ");
    return `${formatTime(from)} - ${to ? formatTime(to) : ""}`;
  };


  const checkAuth = () => {
    const token = localStorage.getItem('EntityTokenA');
    if (!token) {
      navigate('/Entity/login');
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (checkAuth()) {
      fetchEntityData();
      fetchAppointments();
    }
  }, []);

  const fetchEntityData = async () => {
    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/entity/profile`,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.status === 401) {
        localStorage.removeItem('EntityTokenA');
        localStorage.removeItem('EntityData');
        localStorage.removeItem('userType');
        localStorage.removeItem('userId');
        navigate('/Entity/login');
        return;
      }
      
      if (response.ok) {
        const data = await response.json();
        setEntity(data);
      }
    } catch (error) {
      console.error('Error fetching entity data:', error);
    }
  };

  const fetchAppointments = async () => {
    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Entity/appointments`,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.status === 401) {
        localStorage.removeItem('EntityTokenA');
        localStorage.removeItem('EntityData');
        navigate('/Entity/login');
        return;
      }
      
      if (response.ok) {
        const data = await response.json();
        setAppointments(data);
        console.log("fetched appointments data");
        console.log(data);
        
        calculateStats(data);
      }
    } catch (error) {
      console.error('Error fetching appointments:', error);
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = (appointments) => {
    const today = new Date().toISOString().split('T')[0];
    
    const stats = {
      totalAppointments: appointments.length,
      todayAppointments: appointments.filter(apt => 
        apt.appointment_date === today && apt.status !== 'cancelled'
      ).length,
      pendingAppointments: appointments.filter(apt => 
        apt.status === 'pending'
      ).length,
      totalRevenue: appointments
        .filter(apt => apt.payment_status === 'completed')
        .reduce((sum, apt) => sum + parseFloat(apt.amount || 0), 0)
    };
    
    setStats(stats);
  };

  const handleCancelAppointment = async (appointmentId) => {
    if (!window.confirm('هل أنت متأكد من إلغاء هذا الحجز؟')) {
      return;
    }
    
    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/appointment/${appointmentId}/cancelbyentity`,
        {
          method: 'PUT',
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.ok) {
        alert('تم إلغاء الحجز بنجاح');
        fetchAppointments();
      } else {
        const data = await response.json();
        alert(data.message || 'حدث خطأ في إلغاء الحجز');
      }
    } catch (error) {
      console.error('Error cancelling appointment:', error);
      alert('حدث خطأ في الاتصال بالخادم');
    }
  };

  const handleConfirmAppointment = async (appointmentId) => {
    if (!window.confirm('هل أنت متأكد من تأكيد هذا الحجز؟')) {
      return;
    }
    
    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/appointment/${appointmentId}/confirm`,
        {
          method: 'PUT',
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.ok) {
        alert('تم تأكيد الحجز بنجاح');
        fetchAppointments();
      } else {
        const data = await response.json();
        alert(data.message || 'حدث خطأ في تأكيد الحجز');
      }
    } catch (error) {
      console.error('Error confirming appointment:', error);
      alert('حدث خطأ في الاتصال بالخادم');
    }
  };


  const handleBlockSlotSuccess = (data) => {
    setShowBlockSlot(false);
    fetchAppointments();
  };

  const handleScheduleSuccess = (data) => {
    setShowSchedule(false);
    fetchEntityData();
    alert('تم حفظ أوقات العمل بنجاح');
  };

  const handleExceptionsSuccess = (data) => {
    setShowExceptions(false);
    fetchEntityData();
    alert('تم حفظ الاستثناءات بنجاح');
  };

  const getFilteredAppointments = () => {
    return appointments.filter(apt => {
      if (filterDate && apt.appointment_date !== filterDate) return false;
      if (filterPart && apt.reserved_part !== filterPart) return false;
      if (filterStatus !== 'all' && apt.status !== filterStatus) return false;
      return true;
    });
  };

  const getParts = () => {
    if (!entity?.entity_parts_to_reserve_from) return [];
    try {
      const parsed = JSON.parse(entity.entity_parts_to_reserve_from);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('EntityTokenA');
    localStorage.removeItem('EntityData');
    localStorage.removeItem('userType');
    localStorage.removeItem('userId');
    navigate('/Entity/login');
  };

  const filteredAppointments = getFilteredAppointments();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500 flex-center">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500">
      {/* Header */}
      <div className="glass p-4 m-4">
        <div className="flex-between">
          <h1 className="text-white text-2xl font-bold">
            لوحة تحكم الجهة - {entity?.name}
          </h1>
          <button onClick={handleLogout} className="btn btn-secondary">
            تسجيل خروج
          </button>
        </div>
      </div>

      {/* Modals */}
      {showBlockSlot && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex-center z-50 overflow-y-auto">
          <div className="glass p-6 m-4 max-w-4xl w-full max-h-screen overflow-y-auto">
            <EntityBlockSlot 
              entityId={entity?.id}
              onSuccess={handleBlockSlotSuccess}
              onCancel={() => setShowBlockSlot(false)}
            />
          </div>
        </div>
      )}

      {showSchedule && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex-center z-50 overflow-y-auto">
          <div className="glass p-6 m-4 max-w-4xl w-full max-h-screen overflow-y-auto">
            <AvailabilitySchedule 
              entityId={entity?.id}
              onSuccess={handleScheduleSuccess}
              onCancel={() => setShowSchedule(false)}
            />
          </div>
        </div>
      )}

      {showExceptions && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex-center z-50 overflow-y-auto">
          <div className="glass p-6 m-4 max-w-4xl w-full max-h-screen overflow-y-auto">
            <AvailabilityExceptions 
              entityId={entity?.id}
              onSuccess={handleExceptionsSuccess}
              onCancel={() => setShowExceptions(false)}
            />
          </div>
        </div>
      )}

      <div className="container mx-auto p-4">
        {/* Tabs */}
        <div className="flex gap-2 mb-4 flex-wrap">
          <button
            onClick={() => setActiveTab('dashboard')}
            className={`btn ${activeTab === 'dashboard' ? 'btn-primary' : 'btn-secondary'}`}
          >
            📊 الرئيسية
          </button>
          <button
            onClick={() => setActiveTab('appointments')}
            className={`btn ${activeTab === 'appointments' ? 'btn-primary' : 'btn-secondary'}`}
          >
            📅 الحجوزات
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`btn ${activeTab === 'settings' ? 'btn-primary' : 'btn-secondary'}`}
          >
            ⚙️ الإعدادات
          </button>
        </div>

        {/* Quick Actions */}
        {activeTab !== 'settings' && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <button
              onClick={() => setShowBlockSlot(true)}
              className="glass p-4 hover:bg-white hover:bg-opacity-10 cursor-pointer"
            >
              <div className="text-4xl mb-2">🔒</div>
              <div className="text-white font-bold">حجز فترة محلياً</div>
              <div className="text-white opacity-70 text-sm">
                حجز وقت لعميل حضر بدون حجز أونلاين
              </div>
            </button>

            <button
              onClick={() => setShowSchedule(true)}
              className="glass p-4 hover:bg-white hover:bg-opacity-10 cursor-pointer"
            >
              <div className="text-4xl mb-2">⏰</div>
              <div className="text-white font-bold">أوقات العمل</div>
              <div className="text-white opacity-70 text-sm">
                تحديد أيام وأوقات العمل الأسبوعية
              </div>
            </button>

            <button
              onClick={() => setShowExceptions(true)}
              className="glass p-4 hover:bg-white hover:bg-opacity-10 cursor-pointer"
            >
              <div className="text-4xl mb-2">🚫</div>
              <div className="text-white font-bold">الاستثناءات والأجازات</div>
              <div className="text-white opacity-70 text-sm">
                تحديد الأيام غير المتاحة (أعياد، صيانة)
              </div>
            </button>
          </div>
        )}

        {/* Dashboard Tab */}
        {activeTab === 'dashboard' && (
          <div>
            {/* إحصائيات */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div className="glass p-6 text-center">
                <div className="text-4xl mb-2">📊</div>
                <div className="text-white text-3xl font-bold">
                  {stats.totalAppointments}
                </div>
                <div className="text-white opacity-80">إجمالي الحجوزات</div>
              </div>
              
              <div className="glass p-6 text-center">
                <div className="text-4xl mb-2">📅</div>
                <div className="text-white text-3xl font-bold">
                  {stats.todayAppointments}
                </div>
                <div className="text-white opacity-80">حجوزات اليوم</div>
              </div>
              
              <div className="glass p-6 text-center">
                <div className="text-4xl mb-2">⏳</div>
                <div className="text-white text-3xl font-bold">
                  {stats.pendingAppointments}
                </div>
                <div className="text-white opacity-80">قيد الانتظار</div>
              </div>
              
              <div className="glass p-6 text-center">
                <div className="text-4xl mb-2">💰</div>
                <div className="text-white text-3xl font-bold">
                  {stats.totalRevenue.toFixed(2)}
                </div>
                <div className="text-white opacity-80">إجمالي الإيرادات</div>
              </div>
            </div>

            {/* معلومات الجهة */}
            <div className="glass p-6">
              <h2 className="text-white text-xl font-bold mb-4">معلومات الجهة</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-white">
                <div>
                  <p className="opacity-70 text-sm">الاسم</p>
                  <p className="font-bold">{entity?.name}</p>
                </div>
                <div>
                  <p className="opacity-70 text-sm">التخصص</p>
                  <p className="font-bold">{entity?.specialization}</p>
                </div>
                <div>
                  <p className="opacity-70 text-sm">نوع الحجز</p>
                  <p className="font-bold">
                    {entity?.accept_multiple_unit === 'yes' 
                      ? 'حجز متعدد الوحدات (ملاعب)' 
                      : 'حجز بالفترات (قاعات)'}
                  </p>
                </div>
                <div>
                  <p className="opacity-70 text-sm">وحدة الحجز</p>
                  <p className="font-bold">{entity?.reservation_unit} دقيقة</p>
                </div>
                <div>
                  <p className="opacity-70 text-sm">سياسة الإلغاء</p>
                  <p className="font-bold">
                    {entity?.accept_cancellation === 'yes' 
                      ? '✅ يسمح بالإلغاء' 
                      : '❌ لا يسمح بالإلغاء'}
                  </p>
                </div>
                <div>
                  <p className="opacity-70 text-sm">رسوم الحجز</p>
                  <p className="font-bold">{entity?.reservation_fee} جنيه</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Appointments Tab */}
        {activeTab === 'appointments' && (
          <div className="glass p-6">
            <h2 className="text-white text-xl font-bold mb-4">الحجوزات</h2>
            
            {/* فلاتر */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div>
                <label className="text-white block mb-2">التاريخ</label>
                <input
                  type="date"
                  value={filterDate}
                  onChange={(e) => setFilterDate(e.target.value)}
                  className="input"
                />
              </div>
              
              <div>
                <label className="text-white block mb-2">الجزء</label>
                <select
                  value={filterPart}
                  onChange={(e) => setFilterPart(e.target.value)}
                  className="input"
                >
                  <option value="">الكل</option>
                  {getParts().map((part, index) => (
                    <option key={index} value={part}>{part}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="text-white block mb-2">الحالة</label>
                <select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  className="input"
                >
                  <option value="all">الكل</option>
                  <option value="pending">قيد الانتظار</option>
                  <option value="confirmed">مؤكد</option>
                  <option value="completed">مكتمل</option>
                  <option value="cancelled">ملغي</option>
                </select>
              </div>
              
              <div className="flex items-end">
                <button
                  onClick={() => {
                    setFilterDate('');
                    setFilterPart('');
                    setFilterStatus('all');
                  }}
                  className="btn btn-secondary w-full"
                >
                  إعادة تعيين
                </button>
              </div>
            </div>

            {/* قائمة الحجوزات */}
            {filteredAppointments.length === 0 ? (
              <p className="text-white opacity-70 text-center">لا توجد حجوزات</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-white">
                  <thead>
                    <tr className="border-b border-white border-opacity-20">
                      <th className="text-right p-3">رقم الحجز</th>
                      <th className="text-right p-3">العميل</th>
                      <th className="text-right p-3">التاريخ</th>
                      <th className="text-right p-3">الوقت</th>
                      <th className="text-right p-3">الجزء</th>
                      <th className="text-right p-3">المدة</th>

                      <th className="text-right p-3">الحالة</th>
                      <th className="text-right p-3">النوع</th>
                      <th className="text-right p-3">إجراءات</th>

                      <th className="text-right p-3">الخدمات</th>
                      <th className="text-right p-3">ملاحظات</th>

                      <th className="text-right p-3">إجراءات</th>

                    </tr>
                  </thead>
                  <tbody>
                    {filteredAppointments.map((apt) => (
                      <tr 
                        key={apt.id} 
                        className="border-b border-white border-opacity-10 hover:bg-white hover:bg-opacity-10"
                      >
                        <td className="p-3">
                          <div>
                            <div className="font-bold">{apt.id}</div>
                            
                          </div>
                        </td>
                        
                        <td className="p-3">
                          <div>
                            <div className="font-bold">{apt.customer_name}</div>
                            <div className="text-sm opacity-70">{apt.customer_phone}</div>
                          </div>
                        </td>
                        <td className="p-3">{
                        formatDate(apt.appointment_date)
                        }</td>
                        <td className="p-3">
                          {formatTimeRange(`${apt.appointment_time} - ${apt.end_time}`)}
                        </td>
                        <td className="p-3">{apt.reserved_part}</td>
                        <td className="p-3">{apt.reservation_duration} دقيقة</td>
                        <td className="p-3">
                          <span className={`px-2 py-1 rounded text-sm ${
                            apt.status === 'confirmed' ? 'bg-green-500' :
                            apt.status === 'pending' ? 'bg-yellow-500' :
                            apt.status === 'cancelled' ? 'bg-red-500' :
                            'bg-gray-500'
                          }`}>
                            {apt.status === 'confirmed' ? 'مؤكد' :
                             apt.status === 'pending' ? 'قيد الانتظار' :
                             apt.status === 'cancelled' ? 'ملغي' :
                             apt.status === 'completed' ? 'مكتمل' : apt.status}
                          </span>
                        </td>
                        <td className="p-3">
                          {apt.booked_by_entity ? (
                            <span className="px-2 py-1 bg-blue-500 rounded text-sm">
                              محلي
                            </span>
                          ) : (
                            <span className="px-2 py-1 bg-purple-500 rounded text-sm">
                              أونلاين
                            </span>
                          )}
                        </td>


                        <td className="p-3">
                          {apt.status !== 'cancelled' && apt.status !== 'completed' && (
                            <button
                              onClick={() => handleCancelAppointment(apt.id)}
                              className="btn btn-secondary"
                              style={{ padding: '4px 12px', fontSize: '14px' }}
                            >
                              إلغاء
                            </button>
                          )}
                        </td>

                        <td className="p-3">
                          {apt.services  }
                        </td>
                        <td className="p-3">
                          {apt.notes }
                        </td>

                          <td className="p-3">
                          {apt.status !== 'cancelled' && apt.status !== 'confirmed' && (
                            <button
                              onClick={() => handleConfirmAppointment(apt.id)}
                              className="btn btn-primary-3"
                              style={{ padding: '4px 12px', fontSize: '14px' }}
                            >
                              تأكيد
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Settings Tab */}
        {activeTab === 'settings' && (
          <div className="glass p-6">
            <h2 className="text-white text-xl font-bold mb-6">إعدادات الحجز</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <button
                onClick={() => setShowSchedule(true)}
                className="glass-dark p-6 hover:bg-white hover:bg-opacity-10 cursor-pointer text-right"
              >
                <div className="flex items-start gap-4">
                  <div className="text-5xl">⏰</div>
                  <div>
                    <div className="text-white font-bold text-lg mb-2">
                      أوقات العمل الأسبوعية
                    </div>
                    <div className="text-white opacity-70 text-sm">
                      حدد الأيام والأوقات المتاحة للحجز خلال الأسبوع
                    </div>
                  </div>
                </div>
              </button>

              <button
                onClick={() => setShowExceptions(true)}
                className="glass-dark p-6 hover:bg-white hover:bg-opacity-10 cursor-pointer text-right"
              >
                <div className="flex items-start gap-4">
                  <div className="text-5xl">🚫</div>
                  <div>
                    <div className="text-white font-bold text-lg mb-2">
                      الاستثناءات والأجازات
                    </div>
                    <div className="text-white opacity-70 text-sm">
                      حدد الأيام أو الفترات غير المتاحة (أعياد، صيانة، مناسبات)
                    </div>
                  </div>
                </div>
              </button>

              <button
                onClick={() => setShowBlockSlot(true)}
                className="glass-dark p-6 hover:bg-white hover:bg-opacity-10 cursor-pointer text-right"
              >
                <div className="flex items-start gap-4">
                  <div className="text-5xl">🔒</div>
                  <div>
                    <div className="text-white font-bold text-lg mb-2">
                      حجز فترة محلياً
                    </div>
                    <div className="text-white opacity-70 text-sm">
                      حجز وقت محدد لعميل حضر بدون حجز أونلاين
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EntityDashboard;